// extracted by mini-css-extract-plugin
export default {"imageWrapper":"XS-z","hovered":"YS-z","hoverImage":"ZS-z","mainImage":"_S-z","imageNoBackground":"aT-z","fullSizeImage":"bT-z"};